import WorkflowService from "@/services/agency/WorkflowService";
import ScenarioService from "@/services/agency/ScenarioService";

/**
 * Admin-side adapter for the handful of endpoints the ported job-offer form
 * expects from the client app's `ModelService`. In the admin API a "recruitment"
 * is a workflow, reached through the ownership-agnostic `/admin/workflows` routes
 * rather than the caller-scoped `/Workflow` ones the client app uses.
 */
export const getRecruitmentScoringModel = (recruitmentId) =>
    WorkflowService.getScoringModel(recruitmentId);

export const getScenarioScoringModel = (scenarioId) =>
    ScenarioService.getScoringModel(scenarioId);
